// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"7cbc2e40","453":"1fc028d9"}[chunkId] + ".chunk.js";
};